import React from 'react'

import getLabels from '../../utils/getLabels'

const CSVUploadText = () => {
  const label = getLabels('csv_upload_text')
    .replace(
      '{FILE_PATH}',
      '<a href="https://stallotwebsitesprod.z6.web.core.windows.net/transpartner/csv_passenger_details_sample.csv">{LABEL}</a>'
    )
    .replace('{LABEL}', getLabels('csv_file_upload_link'))

  return <p dangerouslySetInnerHTML={{ __html: label }} />
}

export default CSVUploadText
